import { TFunction } from 'i18next';

const usePasswordInput = (t: TFunction, withFormatValidation?: boolean) => {
  let rules: any = {
    required: { value: true, message: t('validation.password.required') },
  };

  if (withFormatValidation) {
    rules = {
      ...rules,
      pattern: {
        value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{8,}$/,
        message: t('validation.password.format'),
      },
    };
  }

  return { rules };
};

export default usePasswordInput;
